// language=GraphQL
export const ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY = `query Query($withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
  prefilteredTravelsBlocks: cmsPrefilteredTravelsBlocks {
    id
    destinations @include(if: $withDestinations) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
      image @include(if: $withTravelTypesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    maxResults
  }
}`

// language=GraphQL
export const SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY = `query Query($id: ID!, $withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
  prefilteredTravelsBlock: cmsPrefilteredTravelsBlock(id: $id) {
    id
    destinations @include(if: $withDestinations) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
      image @include(if: $withTravelTypesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    maxResults
  }
}`

// language=GraphQL
export const CREATE_PREFILTERED_TRAVELS_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsPrefilteredTravelsBlockInput, $withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
    prefilteredTravelsBlock: createCmsPrefilteredTravelsBlock(input: $input) {
      id
      destinations @include(if: $withDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      travelTypes @include(if: $withTravelTypes) {
        id
        name
        description
        image @include(if: $withTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      maxResults
    }
  }`

// language=GraphQL
export const UPDATE_PREFILTERED_TRAVELS_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsPrefilteredTravelsBlockInput, $withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
    prefilteredTravelsBlock: updateCmsPrefilteredTravelsBlock(input: $input) {
      id
      destinations @include(if: $withDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      travelTypes @include(if: $withTravelTypes) {
        id
        name
        description
        image @include(if: $withTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      maxResults
    }
  }`

// language=GraphQL
export const DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsPrefilteredTravelsBlockInput) {
    deleteCmsPrefilteredTravelsBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsPrefilteredTravelsBlockInput) {
    forceDeleteCmsPrefilteredTravelsBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: addCmsPrefilteredTravelsBlockDestinationsInput) {
    addCmsPrefilteredTravelsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const REMOVE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: removeCmsPrefilteredTravelsBlockDestinationsInput) {
    removeCmsPrefilteredTravelsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const CREATE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: createCmsPrefilteredTravelsBlockDestinationsInput) {
    createCmsPrefilteredTravelsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const DELETE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: deleteCmsPrefilteredTravelsBlockDestinationsInput) {
    deleteCmsPrefilteredTravelsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const UPDATE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsPrefilteredTravelsBlockDestinationsOrderInput) {
    updateCmsPrefilteredTravelsBlockDestinationsOrder(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const ADD_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: addCmsPrefilteredTravelsBlockTravelTypesInput) {
    addCmsPrefilteredTravelsBlockTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const REMOVE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: removeCmsPrefilteredTravelsBlockTravelTypesInput) {
    removeCmsPrefilteredTravelsBlockTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const CREATE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: createCmsPrefilteredTravelsBlockTravelTypesInput) {
    createCmsPrefilteredTravelsBlockTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const DELETE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: deleteCmsPrefilteredTravelsBlockTravelTypesInput) {
    deleteCmsPrefilteredTravelsBlockTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const UPDATE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsPrefilteredTravelsBlockTravelTypesOrderInput) {
    updateCmsPrefilteredTravelsBlockTravelTypesOrder(input: $input) {
      id
      travelTypeIds
    }
  }`
